import { SlateEditable } from '../enums';
import { fixAccepts } from './accepts.utils';
import { cleanComponents, removeIds } from './change-slate.utils';
export const compileSlate = (options) => {
    var _a;
    const { slate, slateUpdates } = options;
    const updatedComponents = ((_a = slateUpdates.updatedComponents) === null || _a === void 0 ? void 0 : _a.reduce((preValue, value) => (Object.assign(Object.assign({}, preValue), { [value.id]: value })), {})) || {};
    const { addedComponents = [], removedComponentIds = [] } = slateUpdates;
    const components = [...slate.components, ...addedComponents].map(c => updatedComponents[c.id] ? updatedComponents[c.id] : c);
    const compiledSlate = {
        id: slate.id,
        rootComponents: removeIds(slateUpdates.rootComponents || slate.rootComponents, removedComponentIds),
        acceptsAfter: slate.acceptsAfter !== false,
        acceptsBefore: slate.acceptsBefore !== false,
        acceptsChildren: true,
        editable: slate.editable || SlateEditable.EDIT_COMPONENT,
        components: {},
        parentsMapping: {},
    };
    cleanComponents(components, removedComponentIds).forEach(c => {
        var _a;
        compiledSlate.components[c.id] = c;
        (_a = c.children) === null || _a === void 0 ? void 0 : _a.forEach(child => {
            const arrayChild = Array.isArray(child) ? child : [child];
            arrayChild.forEach(child => {
                compiledSlate.parentsMapping[child] =
                    compiledSlate.parentsMapping[child] || [];
                compiledSlate.parentsMapping[child].push(c.id);
            });
        });
    });
    Object.keys(compiledSlate.components).forEach(c => fixAccepts(compiledSlate, c));
    compiledSlate.rootComponents.forEach(c => {
        const component = compiledSlate.components[c];
        compiledSlate.acceptsAfter =
            compiledSlate.acceptsAfter && (component === null || component === void 0 ? void 0 : component.acceptsAfter) !== false;
        compiledSlate.acceptsBefore =
            compiledSlate.acceptsBefore && (component === null || component === void 0 ? void 0 : component.acceptsBefore) !== false;
        compiledSlate.acceptsChildren =
            compiledSlate.acceptsChildren && (component === null || component === void 0 ? void 0 : component.acceptsChildren) !== false;
    });
    return compiledSlate;
};
//# sourceMappingURL=slate-compiler.utils.js.map